import { conformToMask } from 'react-text-mask'

import { CNPJMask, cpfMask as CPFMask } from 'helpers/masks'
import { phoneMask } from './inputMasks'

export const formatCNPJNumber = rawCNPJNumber => conformToMask(rawCNPJNumber, CNPJMask, { guide: false }).conformedValue

export const formatCPFNumber = rawCPFNumber => conformToMask(rawCPFNumber, CPFMask, { guide: false }).conformedValue

export const formatDocumentNumber = rawDocumentNumber => {
  if (rawDocumentNumber.length > 11) {
    return formatCNPJNumber(rawDocumentNumber)
  }

  return formatCPFNumber(rawDocumentNumber)
}

export const formatCurrency = rawNumber =>
  new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(rawNumber || 0)

export const formatDateTime = rawDateTime =>
  new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short' }).format(new Date(rawDateTime))

export const formatAddress = ({ public_place, number, complement, neighborhood, city, state, zip_code }) =>
  `${public_place}, ${
    complement ? `${number}, ${complement}` : number
  }, ${neighborhood} - ${city}/${state} - ${zip_code}`

export const formatPercentage = (rawNumber, divideByHundred = true) => {
  const value = divideByHundred ? rawNumber / 100 : rawNumber

  return new Intl.NumberFormat('pt-BR', {
    style: 'percent',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value)
}

export const formatPhoneNumber = rawNumber => conformToMask(rawNumber, phoneMask, { guide: false }).conformedValue
